'use client';
import { useGdprConsent } from '#pplx/frontend/analytics/browser/useGdprConsent.js';
import { useUserCapabilities } from '#pplx/frontend/apps/ask/queries/user-queries/useUserCapabilities.js';
import { SIGNUP_BANNER_DISMISSED_KEY } from '#pplx/frontend/apps/ask/signup/signupBannerDismissed.js';
import { useSessionStorage } from '#pplx/frontend/browser-storage/hooks/useSessionStorage.js';
import { useWebPlatform } from '#pplx/frontend/platform-components/useWebPlatform.js';
import { useEffect, useState } from 'react';
export const sidebarSignInButtonClickedEvent = {
    event: 'sidebar sign in button clicked',
    data: {},
};
export function useShouldShowSidebarBottomSignInButton() {
    const { device: { isWindowsApp }, } = useWebPlatform();
    const { isGovernmentRequestOrigin } = useUserCapabilities();
    const isLoadingProfile = isGovernmentRequestOrigin === undefined;
    const [signupBannerDismissed] = useSessionStorage(SIGNUP_BANNER_DISMISSED_KEY, false);
    const [showSignInButton, setShowSignInButton] = useState(isWindowsApp);
    const { showCookieConsentPopup } = useGdprConsent();
    useEffect(() => {
        if (signupBannerDismissed || showCookieConsentPopup) {
            setShowSignInButton(true);
        }
    }, [showCookieConsentPopup, signupBannerDismissed]);
    useEffect(() => {
        // Wait for the profile before choosing this button over the signup upsell.
        if (!isLoadingProfile && isGovernmentRequestOrigin) {
            setShowSignInButton(true);
        }
    }, [isLoadingProfile, isGovernmentRequestOrigin]);
    return showSignInButton;
}
//# sourceMappingURL=SideBarBottomSignInButtonShared.js.map